import React, {useState} from "react";
import styles from "./gender.module.css";
import {useDispatch} from "react-redux";
import {addMessage, setWaitingResponse} from "../../store/stateSlice";
import FemaleImage from "./images/female.svg";
import MaleImage from "./images/male.svg";
import OtherImage from "./images/other.svg";
import {updateProfile} from "../../../../api";

const GenderButtons = ({ title }) => {
  const dispatch = useDispatch();

  const [hidden, setHidden] = useState(false);

  const handleClick = (answer) => {
    setHidden(true);
    dispatch(addMessage(answer.replace(/^./, str => str.toUpperCase())));
    dispatch(setWaitingResponse());

    updateProfile({
      land: "tarot-chat",
      step: "step2",
      topicType: "gender",
      topic: title,
      answer: {
        gender: answer
      }
    })

  };
  return (
    <div>
      <p>{title}</p>
      {!hidden && (
        <div className={styles.button_container}>
          <button className={styles.button} onClick={() => handleClick("man")}><img src={FemaleImage} alt=""/> Man</button>
          <button className={styles.button} onClick={() => handleClick("woman")}><img src={MaleImage} alt=""/> Woman</button>
          <button className={styles.button} onClick={() => handleClick("other")}><img src={OtherImage} alt=""/> Other</button>
        </div>
      )}
    </div>
  );
};

export { GenderButtons };
